import React from 'react';

import { FormSection, FormToggle, getFieldName } from 'widgets';

import { AddressBlock } from './AddressBlock';
import { ComplianceRequirements } from './ComplianceRequirements';
import { FinancialPicture } from './FinancialPicture';
import { PersonAdvancedBlock } from './PersonAdvancedBlock';
import { PersonBasicFormFields } from './PersonBasicFormFields';

export const PersonFormFields = ({ prefix = '', hasDivider = false }: { prefix?: string; hasDivider?: boolean }) => {
    return (
        <>
            <PersonBasicFormFields prefix={prefix} hasDivider={hasDivider} />

            <AddressBlock prefix={prefix} />

            <FormSection title="Financial Picture" hasDivider>
                <FinancialPicture prefix={prefix} />
            </FormSection>

            <FormSection title="Compliance Requirements" hasDivider>
                <ComplianceRequirements prefix={prefix} />
                <FormToggle name={getFieldName('ndvrAffiliated', prefix)} label="Claro Affiliated" />
            </FormSection>

            <FormSection title="Advanced" hasDivider>
                <PersonAdvancedBlock prefix={prefix} />
                <FormToggle
                    name={getFieldName('advisor', prefix)}
                    label="Advisor"
                    description="Allow this person to be automatically assigned as Primary Advisor for self-service accounts"
                />
            </FormSection>
        </>
    );
};
